<cs-header [backButton]="false">
  <cs-header-title>
    <div class="month-nav">
      <cs-icon-button (click)="onMonthBackClick()" icon="arrow-dropleft" size="small"
        [style.visibility]="viewMode === ViewMode.Calendar ? 'visible' : 'hidden'"></cs-icon-button>
      <!-- the year branch is a raw formatted number, and monthYearHeader is already
           localized text from formatMonthYearLong() -->
      <cs-button tertiary neutral class="month-year-btn"
        [label]="(viewMode === ViewMode.MonthPicker ? '' + viewDate.year : monthYearHeader) | untranslated"
        [icon-right]="viewMode === ViewMode.Calendar ? 'caret-down' : 'caret-up'"
        (click)="onHeaderClick()"></cs-button>
      <cs-icon-button (click)="onMonthForwardClick()" icon="arrow-dropright" size="small"
        [style.visibility]="viewMode === ViewMode.Calendar ? 'visible' : 'hidden'"></cs-icon-button>
    </div>
  </cs-header-title>
</cs-header>

<cs-content [no-scroll]="true">
  <!-- Calendar View - defines the height -->
  <div class="calendar-view" [class.hidden]="viewMode !== ViewMode.Calendar">
    <div class="date-row">
      <div class="date-display">{{ shortDateHeader }}</div>
      <cs-button secondary small (click)="onTodayClick()">{{ LL.common.buttons.today() }}</cs-button>
    </div>

    <div class="calendar-grid">
      <div class="weekdays">
        @for (d of weekdays; track d.name) {
          <div class="day">{{ d.name }}</div>
        }
      </div>

      @for (w of weeks; track w.days[0].id) {
        <div class="week">
          @for (d of w.days; track d.id) {
            <div class="day" tappable [id]="d.id" [ngClass]="{
              selected: d.id === selectedId && !d.outOfMonth,
              today: d.id === todayId && d.id !== selectedId && !d.outOfMonth,
              'out-of-month': d.outOfMonth || d.id > maxDate.toISODate() || d.id < minDate.toISODate()
            }" (click)="onDayClick(d)">
              <button cs-capture-cover></button>
              {{ d.day }}
            </div>
          }
        </div>
      }
    </div>

    <!-- Year Picker View - positioned inside calendar-view -->
    <div class="year-view" [class.hidden]="viewMode !== ViewMode.YearPicker">
      <div class="year-grid" #yearGrid>
        @for (year of years; track year) {
          <div class="year-cell"
            [attr.data-year]="year"
            [ngClass]="{ selected: year === viewDate.year }"
            tappable
            (click)="onYearSelect(year)">
            <button cs-capture-cover></button>
            <span>{{ year }}</span>
          </div>
        }
      </div>
    </div>

    <!-- Month Picker View - positioned inside calendar-view -->
    <div class="month-view" [class.hidden]="viewMode !== ViewMode.MonthPicker">
      <div class="month-grid">
        @for (month of months; track month.index) {
          <div class="month-cell"
            [ngClass]="{ selected: month.index === viewDate.month }"
            tappable
            (click)="onMonthSelect(month.index)">
            <button cs-capture-cover></button>
            <span>{{ month.name }}</span>
          </div>
        }
      </div>
    </div>
  </div>
</cs-content>
<cs-page-action-buttons>
  <cs-button secondary [label]="LL.common.buttons.cancel()" (click)="onCancelClick()"></cs-button>
  <cs-button primary [label]="LL.common.buttons.apply()" (click)="onOKClick()"></cs-button>
</cs-page-action-buttons>
